import React from "react";
import { Button } from "../../../components";
import Home from "../../../assets/teams/home.png";

const ForumBox = () => {
  return (
    <>
      <div className="flex justify-between forum-box mt-10">
        <div className="flex items-center">
          <div className="w-20 h-20 rounded-full">
            <img src={Home} />
          </div>
          <div>
            <h3 className="text-xl font-bold">Basketball</h3>
            <p>@basketball</p>
            <label>Build fans has to be with intentions</label>
          </div>
         
        </div>
        <div>
          <Button
            type="primary"
            className="mt-0 primary-color button-tetiary"
            title="Follow"
            style={{
              height: "20px",
              borderRadius: "50px",
              paddingLeft: "2.5em",
              paddingRight: "2.5em",
            }}
          />
        </div>
      </div>
    </>
  );
};

export default ForumBox;